<template>
  <div class="m-collection">
    <header-nav ref="router" theme="1"></header-nav>
    <base-login></base-login>
    <el-container class="container">
      <el-header height="147px">
        <div class="breadcrumb-wrap">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
            <el-breadcrumb-item
              ><a href="/seeker/person.html">个人中心</a></el-breadcrumb-item
            >
            <el-breadcrumb-item>我的收藏</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <kzptabs
          :tabs-list="tabsList"
          :total="tabsCount"
          :tabs-index="activeName * 1"
          @changtab="tabChangHandle"
        ></kzptabs>
      </el-header>
      <el-main class="page-main">
        <div class="batch-control" style="text-align: right">
          <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
            >全选 </el-checkbox
          >&emsp;
          <el-link type="primary" @click="handleMark('cancel')"
            >取消收藏
          </el-link>
        </div>
        <div class="table-wrap" v-loading="initPage">
          <div class="table-wrap">
            <div
              class="infinite-list"
              :style="'overflow:auto; min-height:' + grid.height + 'px;'"
            >
              <template v-if="tableData[activeName].length > 0">
                <div
                  class="infinite-list-wrap"
                  v-infinite-scroll="loadNextPage"
                  infinite-scroll-immediate="false"
                >
                  <div
                    v-for="(item_card, index) in tableData[activeName]"
                    :key="index"
                    class="infinite-list-item"
                  >
                    <el-card shadow="hover">
                      <div class="tab-list">
                        <div class="check-wrap">
                          <el-checkbox
                            v-model="ids[index]"
                            false-label=""
                            :true-label="item_card.id"
                            @change="handleCheckedChange(index)"
                          ></el-checkbox>
                        </div>
                        <div
                          style="padding: 5px 0; cursor: pointer;width: 60%;"
                          @click="goDetail(item_card.publish_id)"
                        >
                          <p style="margin-bottom: 8px">
                            <span style="font-size: 16px; font-weight: bold">
                              {{ item_card.job_name || "--" }} </span
                            >&emsp;
                            <span style="font-size: 16px; font-weight: bold">
                              {{ item_card.salary || "--" }}</span
                            >
                          </p>
                          <p class="text-list">
                            <span>{{ item_card.company_name }}</span>
                            <span>{{ item_card.city_name }}</span>
                            <span>{{ item_card.degree_require }}</span>
                          </p>
                        </div>
                        <div class="tab-btns">
                          <el-link type="default" :underline="false">
                            收藏时间：{{ item_card.create_time }}
                          </el-link>
                          <p class="tab-btns-b">
                            <template
                              v-for="(item, index) in tabsList[activeName].operation">
                              <el-link
                                type="primary"
                                :underline="false"
                                :key="index"
                                @click.native.stop.prevent="handleMark(item.type, item_card)"
                              >
                                {{ item.label }}&nbsp;
                              </el-link>
                            </template>
                            <invite-resume
                              v-if="!(item_card.is_send === '1' || item_card.job_status !== '1' || item_card.is_publish != '1' || item_card.is_expire)"
                              :params="item_card"
                              btn-type="link"
                              type="text"
                              btn-text="投递简历"
                              @success="refresh"
                            ></invite-resume>
                            <el-link
                              :underline="false"
                              type="info"
                              disabled
                              v-if="item_card.job_status !== '1' ||item_card.is_publish != '1' ||item_card.is_expire"
                            >
                              职位已下架
                            </el-link>
                            <el-link
                              :underline="false"
                              type="success"
                              disabled
                              v-if="item_card.is_send == '1'"
                              >已投递
                            </el-link>
                          </p>
                        </div>
                      </div>
                    </el-card>
                  </div>
                </div>
                <el-row
                  style="height: 50px"
                  v-if="loading"
                  v-loading="loading"
                  element-loading-text="拼命加载中"
                  element-loading-spinner="el-icon-loading"
                ></el-row>

                <el-divider v-if="pageParams[activeName].noMore">
                  这是我的底线哦~
                </el-divider>
              </template>

              <el-divider v-else>
                <span v-show="!initPage">暂无数据</span>
              </el-divider>
            </div>
          </div>
        </div>
        <float-window
          :items="floatData.item"
          :curr-item="floatData.currItem"
        ></float-window>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Kzptabs from "@/components/KzpTabs";
import FloatWindow from "@/components/FloatWindow/FloatWindow";

import InviteResume from "@/components/Invite/InviteResume";

export default {
  name: "m_collection",
  components: {
    kzptabs: Kzptabs,
    floatWindow: FloatWindow,
    InviteResume
  },
  computed: {
    
  },
  filters: {
    stateFilter: function (value, status) {
      let stateTxt = "";
      if (value * 1 === 0) {
        stateTxt = "待企业确认";
      } else if (value * 1 === 2) {
        stateTxt = "已拒绝";
      } else {
        if (status === "0") {
          stateTxt = "待面试";
        } else {
          stateTxt = "已面试";
        }
      }
      return stateTxt;
    },
  },
  data() {
    return {
      initPage: true,
      activeName: 0,
      loading: false,
      grid: {
        height: 500,
      },
      filter: {
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [[]],
      checkBoxList: [],
      checkAll: false,

      tabsList: [
        {
          label: "收藏的职位",
          keys: "job",
          operation: [
            { label: "取消收藏", type: "cancel" },
            // {label: '投递简历', type: 'resume'},
          ],
        },
      ],
      tabsCount: ["", ""],
      ids: [],
      publish_ids: [],
      resumes_id: "",
      floatData: {
        item: [
          {
            label: "最近投递",
            link: "/seeker/person/r_delivery.html",
            icon: "icontoudilishi",
          },
          {
            label: "我的收藏",
            link: "/seeker/person/m_collection.html",
            icon: "iconshoucang",
          },
          {
            label: "我的申请",
            link: "/seeker/person/m_apply.html",
            icon: "iconshenqing",
          },
          {
            label: "企业邀约",
            link: "/seeker/person/c_invited.html",
            icon: "iconact_yaoyue",
          },
        ],
        currItem: "1",
      },
      pageParams: [{ noMore: false, pageNo: 1, pageSize: 8 }],
    };
  },
  mounted: function () {
    this.getMyCollectionFn();
    this.initHeight();
  },
  methods: {
    getList: function (method, params) {
      let _self = this;
      return new Promise((resolve) => {
        this.$util
          .get("kzp_person", method, params)
          .then((res) => {
            if (res && res.code === 1) {
              resolve(res);
            } else {
              resolve({ code: -1, data: [] });

              if (res.msg) {
                _self.$message.error(res.msg);
              }
            }
          })
          .catch(() => {
            // 处理不提示的错误!
          });
      });
    },
    getMyCollectionFn(type) {
      let _self = this;
      let filter = _self.filter;

      if (type === "page") {
        filter.pageNo = 1;
      }

      _self.loading = true;
      filter.video_jobfair_id = "";

      _self.getList("my_attention", filter).then(function (res) {
        _self.loading = false;
        if (res.data.total) {
          if (filter.pageNo === 1) {
            _self.$set(_self.tableData, _self.activeName, res.data.list);
            _self.initPage = false;
          } else {
            _self.tableData[_self.activeName] = [
              ..._self.tableData[_self.activeName],
              ...res.data.list,
            ];
          }
          _self.$set(_self.tabsCount, _self.activeName, res.data.total);
        }

        if (res.data.total <= _self.tableData[_self.activeName].length) {
          filter.noMore = true;
        }
      });
    },
    tabChangHandle(tab) {
      this.handleClick(tab);
    },
    handleClick(tab) {
      if (tab && tab.index >= 0) {
        this.activeName = tab.index || 0;
        if (this.tableData[this.activeName].length > 0) {
          return true;
        }
        this.initPage = true;
        this.refresh();
      }
    },
    refresh: function () {
      this.getMyCollectionFn("page");
    },
    initHeight() {
      const height =
        window.innerHeight -
        document.querySelector(".header-nav").clientHeight -
        document.querySelector(".el-header").clientHeight -
        60;
      this.grid.height = height;
    },
    goDetail(id) {
      this.$util.pageto("jobfair_job", { publish_id: id });
    },
    //处理操作
    handleMark(type, card) {
      let _self = this;
      if (type === "cancel") {
        //取消收藏
        let tip = "";
        if (!!card) {
          _self.ids = [card.id];
          tip = "【" + card.job_name + "】";
        } else {
          if (_self.ids.length < 1) {
            _self.$message.error("请至少选择一个职位");
            return false;
          } else {
            tip = _self.ids.length + "个职位";
          }
        }

        _self.confirmFn({ tip: "是否确定取消收藏" + tip + "?" }, function () {
          _self.cancelCollection();
        });
      }
    },
    //取消收藏
    cancelCollection() {
      let _self = this;
      let params = { ids: _self.ids };
      _self.$util
        .post("kzp_person", "collect_job_cancel", params)
        .then((res) => {
          const { code, msg } = res;
          if (code === 1) {
            _self.ids = [];
            _self.$message({
              message: "操作成功",
              type: "success",
            });
            _self.refresh();
          } else {
            _self.$message.error(msg);
          }
        })
        .catch(() => {
          // 处理不提示的错误!
        });
    },
    //确认弹框
    confirmFn(option, success, cancel) {
      this.$confirm(option.tip || "是否确定执行？", option.title || "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (success && typeof success === "function") {
            success();
          }
        })
        .catch(() => {
          if (cancel && typeof cancel === "function") {
            cancel();
          }
        });
    },
    //全选
    handleCheckAllChange(val) {
      if (val) {
        let ids = this.tableData[this.activeName].map((obj) => {
          return obj.id;
        });
        this.$set(this, "ids", ids);
      } else {
        let ids = this.tableData[this.activeName].map((obj) => {
          return "";
        });
        this.$set(this, "ids", ids);
      }
    },

    handleCheckedChange(index) {
      if (this.ids[index]) {
        let arr = this.ids.filter(function (el) {
          return el !== "";
        });
        if (
          arr.length === this.tableData[this.activeName].length &&
          arr.length > 0
        ) {
          this.checkAll = true;
        }
      } else {
        if (this.checkAll) this.checkAll = false;
      }
    },

    loadNextPage() {
      let params = this.pageParams[this.activeName];
      if (this.loading || params.noMore) {
        return false;
      }
      params.pageNo++;
      this.getMyCollectionFn();
    },
  },
};
</script>

<style lang="scss" scoped>
.m-collection {
  .page-tit {
    margin: 0;
    padding: 10px 0;
    font-size: 16px;
    font-weight: bold;
  }

  .breadcrumb-wrap {
    padding: 25px 0px;
  }

  .table-wrap {
    margin-top: 15px;

    .filter-wrap {
      margin-bottom: 10px;
    }
  }

  .infinite-top-tip {
    font-size: 12px;
    line-height: 17px;
    margin-bottom: 10px;
    color: #999999;
  }

  .infinite-list-item {
    margin-bottom: 8px;

    .tab-list {
      display: table;
      width: 100%;
      vertical-align: middle;
    }

    .tab-list > div {
      display: table-cell;
      vertical-align: middle;
      border: none;
    }

    .text-list {
      color: #999;

      & > span {
        margin-right: 10px;
        font-size: 14px;
      }

      .iconfont {
        font-size: 13px;
      }
    }

    img {
      width: 100%;
      max-height: 100%;
    }

    .el-card__body {
      padding: 20px;
    }

    .tab-btns {
      text-align: right;

      .tab-btns-b {
        margin-top: 10px;

        & > a {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/seeker/person/m_collection/App.vue